import React from "react";

function RefundPolicy() {
  return (
    <div className="policy-page container">
      <style>{`
        .policy-page {
          max-width: 900px;
          margin: 0 auto;
          padding: 50px 20px;
          font-family: "Helvetica Neue", Arial, sans-serif;
          color: #333;
          line-height: 1.8;
        }
        .policy-title {
          font-size: 2.2rem;
          text-align: center;
          margin-bottom: 10px;
          color: #2c2c2c;
        }
        .last-updated {
          text-align: center;
          color: #777;
          margin-bottom: 40px;
          font-size: 0.9rem;
        }
        .policy-page section {
          margin-bottom: 40px;
        }
        .policy-page h2 {
          font-size: 1.4rem;
          color: #444;
          margin-bottom: 15px;
          border-left: 4px solid #d19c65; /* Accent color */
          padding-left: 10px;
        }
        .policy-page p {
          font-size: 1rem;
          margin-bottom: 15px;
        }
        .policy-page ul {
          list-style: disc inside;
          margin-top: 10px;
        }
        .policy-page li {
          margin-bottom: 8px;
          font-size: 1rem;
        }
        @media (max-width: 768px) {
          .policy-page {
            padding: 30px 15px;
          }
          .policy-title {
            font-size: 1.8rem;
          }
          .policy-page h2 {
            font-size: 1.2rem;
          }
        }
      `}</style>

      <h1 className="policy-title">Refund Policy</h1>
      {/* <p className="last-updated">Last updated: September 11, 2025</p> */}

      <section>
        <h2>Eligibility for Refunds</h2>
        <p>
          We want you to be satisfied with your purchase. If you are not happy
          with your order, you may request a refund within{" "}
          <strong>7 days</strong> of receiving your product, provided it meets
          the conditions outlined below.
        </p>
      </section>

      <section>
        <h2>Conditions for Refunds</h2>
        <ul>
          <li>The item must be unused and in its original packaging.</li>
          <li>
            Proof of purchase (invoice or receipt) must be provided when
            requesting a refund.
          </li>
          <li>
            Refunds are not applicable for items marked as final sale or
            non-returnable.
          </li>
        </ul>
      </section>

      <section>
        <h2>Refund Process</h2>
        <p>
          To initiate a refund, please contact our support team with your order
          details and reason for return. Once your request is approved, we will
          provide instructions for returning the product.
        </p>
      </section>

      <section>
        <h2>Processing Time</h2>
        <p>
          Refunds are typically processed within{" "}
          <strong>7–10 business days</strong> after we receive the returned
          product and verify its condition. The refund will be credited to your
          original method of payment.
        </p>
      </section>

      <section>
        <h2>Partial Refunds</h2>
        <p>
          In certain cases, only partial refunds may be granted, such as items
          that show signs of use, are returned after the eligible window, or
          have missing parts not due to our error.
        </p>
      </section>

      <section>
        <h2>Damaged or Defective Items</h2>
        <p>
          If you receive a damaged or defective product, please notify us within{" "}
          <strong>48 hours</strong> of delivery with supporting photos. We will
          arrange for a replacement or issue a full refund.
        </p>
      </section>

      {/* <section>
        <h2>Contact Us</h2>
        <p>
          For any questions or concerns regarding this Refund Policy, please
          contact our support team:
        </p>
        <ul>
          <li>Email: support@yourwebsite.com</li>
          <li>Phone: +91-XXXXXXXXXX</li>
        </ul>
      </section> */}
    </div>
  );
}

export default RefundPolicy;
